import Vue from 'vue';
import VueRouter from 'vue-router';

import RootLayout from '@/layouts';

import Main from '@/views/Main';
import Portfolio from '@/views/Portfolio';
import PortfolioDetails from '@/views/PortfolioDetails';
import AboutUs from '@/views/AboutUs';
import Resources from '@/views/Resources';
import ResourcesDetails from '@/views/ResourcesDetails';
import Process from '@/views/Process';
import Expertise from '@/views/Expertise';
import ExpertiseInteract from '@/views/ExpertiseInteract';
import ExpertiseUx from '@/views/ExpertiseUx';
import ExpertiseDesignReview from '@/views/ExpertiseDesignReview';
import ExpertiseAi from '@/views/ExpertiseAi';
import ExpertiseUi from '@/views/ExpertiseUi';
import ExpertiseGraphicDesign from '@/views/ExpertiseGraphicDesign';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '',
      component: RootLayout,
      children: [
        {
          path: '',
          redirect: '/main',
        },
        {
          path: '/main',
          component: Main,
        },
        {
          path: '/portfolio/:id',
          component: PortfolioDetails,
        },
        {
          path: '/portfolio',
          component: Portfolio,
        },
        {
          path: '/team',
          component: AboutUs,
        },
        {
          path: '/resources',
          component: Resources,
        },
        {
          path: '/resources/:id',
          name: 'ResourcesDetails',
          component: ResourcesDetails,
        },
        {
          path: '/process',
          component: Process,
        },
        {
          path: '/expertise',
          component: Expertise,
        },
        {
          path: '/expertise/interact',
          component: ExpertiseInteract,
        },
        {
          path: '/expertise/ux',
          component: ExpertiseUx,
        },
        {
          path: '/expertise/design-review',
          component: ExpertiseDesignReview,
        },
        {
          path: '/expertise/ai',
          component: ExpertiseAi,
        },
        {
          path: '/expertise/ui',
          component: ExpertiseUi,
        },
        {
          path: '/expertise/graphic-design',
          component: ExpertiseGraphicDesign,
        },
      ],
    },
  ],
   scrollBehavior: (to, from, savedPosition) => {
     if (to.name === 'ResourcesDetails' && from.name === 'ResourcesDetails') {
       return savedPosition || { x: 0, y: 0 };
     }
     return savedPosition || { x: 0, y: 0 };
  },
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js